import { useEffect, useState } from "react";
import { OrderSheet } from "../../components/OrderInfo"
import { getOrders } from "../../service/api/Order/apiOrder";

const OrderInfo = () => {
    const [ordersData, setOrdersData] = useState([]);
    const [count, setCount] = useState(0);
    useEffect(() => {
        getOrders({page: 1, limit: 10})
            .then(response => {
                if (response?.status === 200) {
                    console.log(response)
                    setOrdersData(response.data.result);
                    setCount(response.data.count);
                }
            });
    }, []);
    return (
        <>
            <div className="card ">
                <OrderSheet
                    data={ordersData}
                    count={count} />
            </div>
        </>
    )
}
export { OrderInfo }